import { styled } from '@mui/material/styles';

import { FONTS } from '../../shared/theme/typography';
import { CARD_BG, CARD_INK } from './backdrop';

/**
 * The surfaces the account page and the sign-up questions are built from: cards
 * of translucent parchment over the photograph, and the chips an answer is
 * shown as. The papers themselves are in `backdrop.ts` with the rest of the
 * page's palette; the two glyphs the mockups draw are in `accountGlyphs.tsx`.
 */

export const Card = styled('div')({
  boxSizing: 'border-box',
  background: CARD_BG,
  color: CARD_INK,
  borderRadius: 22,
});

/** One answer, as the mockups draw it: the emoji, then the words. */
export const Chip = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 9,
  minHeight: 27,
  padding: '3px 14px 3px 10px',
  borderRadius: 999,
  background: '#f3eee7',
  color: CARD_INK,
  fontFamily: FONTS.display,
  fontWeight: 700,
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  '& > b': {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 700,
  },
});

/**
 * An emoji, drawn from the system's own colour font.
 *
 * `font-family` is set explicitly: Cy Text has no pictographs, and letting it
 * fall through the body stack first costs a frame of tofu on Windows.
 */
export const Emoji = styled('span')({
  flexShrink: 0,
  lineHeight: 1,
  fontFamily:
    '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", "Twemoji Mozilla", sans-serif',
});
